

export const SET_LOCALE = 'SET_LOCALE';
export const SET_AVATAR = 'SET_AVATAR';
export const SET_ROUTER_HISTORY = 'SET_ROUTER_HISTORY';

